import { isEmptyArray } from '../../../../utils/array-utils';
import { logger } from '../../../../utils/logger';
import { nonEmptyStringValidator } from '../../../../utils/validators/string';
import { isSeatFirstOrderingForShowtime } from '../../../browsing/selectors/showtimes/is-seat-first-ordering-for-showtime';
import { getOrderSeatCountForShowtime } from '../../selectors/seats/get-order-seat-count-for-showtime';
import { getOrderSeatCountPerAreaCategory } from '../../selectors/seats/get-order-seat-count-per-area-category';
import { getOrderTicketCountForShowtime } from '../../selectors/tickets/get-order-ticket-count-for-showtime';
import { getOrderTicketCountPerAreaCategory } from '../../selectors/tickets/get-order-ticket-count-per-area-category';
import { TicketSelectionValidationError } from '../../types/ticket-selection-validation-error';
export const validateOrderTicketsForShowtime = (showtimeId) => {
    if (!nonEmptyStringValidator(showtimeId, logger.error, 'showtimeId')) {
        throw new Error('Cannot validate selected tickets. Provided showtimeId is invalid.');
    }
    const isSeatFirstOrdering = isSeatFirstOrderingForShowtime(showtimeId);
    const errors = isSeatFirstOrdering
        ? getSeatFirstTicketSelectionErrors(showtimeId)
        : getTicketFirstTicketSelectionErrors(showtimeId);
    return isEmptyArray(errors) ? { isValid: true } : { isValid: false, errors };
};
const getTicketFirstTicketSelectionErrors = (showtimeId) => {
    const errors = [];
    if (getOrderTicketCountForShowtime(showtimeId) === 0) {
        errors.push(TicketSelectionValidationError.NoTicketsSelected);
    }
    return errors;
};
const getSeatFirstTicketSelectionErrors = (showtimeId) => {
    const errors = [];
    const totalSeatCount = getOrderSeatCountForShowtime(showtimeId);
    const totalTicketCount = getOrderTicketCountForShowtime(showtimeId);
    if (totalSeatCount > totalTicketCount)
        errors.push(TicketSelectionValidationError.TooFewTickets);
    else if (totalTicketCount > totalSeatCount)
        errors.push(TicketSelectionValidationError.TooManyTickets);
    const seatCountPerAreaCategory = getOrderSeatCountPerAreaCategory(showtimeId);
    const ticketCountPerAreaCategory = getOrderTicketCountPerAreaCategory(showtimeId);
    const areaCategoryCodes = Array.from(seatCountPerAreaCategory.keys());
    areaCategoryCodes.forEach(areaCategoryCode => {
        const seatCount = seatCountPerAreaCategory.get(areaCategoryCode);
        const ticketCount = ticketCountPerAreaCategory.get(areaCategoryCode);
        if (seatCount !== ticketCount)
            errors.push(TicketSelectionValidationError.TicketsDoNotMatchSelectedSeats);
    });
    return errors;
};
